import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene la lista paginada de Tickets
 */
export const getTicketsPaginados = (setTickets, setError, pageNumber = 1, pageSize = 10, searchTerm = "", eventoId = null, usuarioId = null, estadoTicket = null, token) => {
    return new Promise((resolve, reject) => {
        let url = `/Ticket/paged?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        
        if (searchTerm && searchTerm.trim() !== "") {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }
        
        if (eventoId) {
            url += `&eventoId=${eventoId}`;
        }
        
        if (usuarioId) {
            url += `&usuarioId=${usuarioId}`;
        }
        
        if (estadoTicket) {
            url += `&estadoTicket=${estadoTicket}`;
        }
        
        HttpCliente.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setTickets(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene información de un Ticket por ID
 */
export const getTicketById = (id, setTicket, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Ticket/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setTicket(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene tickets por código
 */
export const getTicketByCode = (codigo, setTicket, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Ticket/by-code/${codigo}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setTicket(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene tickets por usuario
 */
export const getTicketsByUser = (usuarioId, setTickets, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Ticket/user/${usuarioId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setTickets(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene tickets por evento
 */
export const getTicketsByEvento = (eventoId, setTickets, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Ticket/evento/${eventoId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setTickets(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene estadísticas de tickets por evento
 */
export const getTicketStatsByEvento = (eventoId, setStats, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Ticket/evento/${eventoId}/stats`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setStats(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene resumen de tickets por evento
 */
export const getEventoTicketSummary = (eventoId, setSummary, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Ticket/evento/${eventoId}/summary`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setSummary(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * POST method - Crea un nuevo Ticket
 */
export const createTicket = (ticketData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Ticket", ticketData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 201 || response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al crear el ticket";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * POST method - Crea múltiples tickets
 */
export const createTicketsBulk = (ticketsData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Ticket/bulk", ticketsData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 201 || response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al crear los tickets";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PUT method - Actualiza un ticket existente
 */
export const updateTicket = (id, ticketData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/Ticket/${id}`, ticketData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al actualizar el ticket";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PATCH method - Marca un ticket como usado
 */
export const markTicketAsUsed = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.patch(`/Ticket/${id}/use`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al usar el ticket";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PATCH method - Marca ticket como usado por código
 */
export const markTicketAsUsedByCode = (codigo, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.patch(`/Ticket/use-by-code/${codigo}`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al usar el ticket";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PATCH method - Toggle status de un ticket
 */
export const toggleTicketStatus = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.patch(`/Ticket/${id}/toggle-status`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al cambiar estado del ticket";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PATCH method - Cancela un ticket
 */
export const cancelTicket = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.patch(`/Ticket/${id}/cancel`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al cancelar el ticket";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Valida un ticket por código
 */
export const validateTicket = (codigo, setValidation, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Ticket/validate/${codigo}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setValidation(response.data.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al validar el ticket";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * DELETE method - Elimina un ticket
 */
export const deleteTicket = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.delete(`/Ticket/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al eliminar el ticket";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};